/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { PsTreeItem } from "../../../../../api/model";
import { toString } from "../../../../../utils/string";
import Modal from "../../../../modules/Modal";

interface Props {
  /** モーダル表示・非表示状態。 */
  isOpen: boolean;

  /** モーダル表示・非表示状態設定関数。 */
  setIsOpen: (isOpen: boolean) => void;

  /** PS ツリーで右クリックで選択された PsTreeItem。 */
  selectedPsTreeItem: PsTreeItem;

  // /** PS ツリーで右クリックで選択された PS のバージョン ID。 */
  // selectedPsVersionId: number;

  // /** PS ツリーで右クリックで選択された PS の種別。 */
  // selectedPsType: number;
}

// PS 閲覧画面で使用。
/** PS 種別選択ダイアログ (PS 追加用)。 */
function PsAddDialog(
  {
    isOpen,
    setIsOpen,
    selectedPsTreeItem,
    // selectedPsVersionId,
    // selectedPsType,
  }: Props
) {
  // i18n 用。
  const {
    t,
    i18n,
  } = useTranslation();

  const navigate = useNavigate();

  /** 新規作成する PS の種別の state。 */
  const [newPsType, setNewPsType] = useState<number>(-1);

  useEffect(
    () => {
      if (isOpen) {
        // 表示される度にリセット。
        setNewPsType(-1);
      }
    },
    [isOpen]
  );

  /** 新規作成する PS の種別の option の配列。 */
  const typeOptions = [
    {
      value: -1,
      label: t('選択してください'),
    },
    {
      value: 1,
      label: t('章PS'),
    },
    {
      value: 2,
      label: t('タイトル'),
    },
    {
      value: 3,
      label: t('コンテンツ'),
    },
  ];

  // 選択 PS が
  // ルート PS の場合: [選択してください], [章PS]
  // L1 - L4 の場合: [選択してください], [タイトル], [コンテンツ]
  // L5 の場合: [選択してください], [コンテンツ]
  // レベル 5 のタイトル PS およびコンテンツ PS を右クリック → 追加メニュー → PS 追加ダイアログを表示した際には PS の種別として「タイトル」は選べないようにする。
  // ちなみに、バックエンドでは、コンテンツ PS を右クリックして、コンテンツ PS を追加の場合、選択したコンテンツ PS の弟として追加し、タイトル PS を追加の場合は、選択したコンテンツ PS の親 PS の末子として追加するように実装されている。
  typeOptions.splice(
    (selectedPsTreeItem.type === 0) ?
      2
      :
      1,
    (selectedPsTreeItem.type === 0) ?
      2
      :
      (
        (Number(selectedPsTreeItem.level) < 5) ?
          1
          :
          2
      )
  );

  // console.log('typeOptions: ', typeOptions);

  return (
    <Modal
      active={isOpen}
      additionalClassName='popupfr380 pt30'
      displayCloseButton
      onClose={() => {
        setIsOpen(false);
      }}
    >
      <div className="windowone">
        <div>
          <label>{t('PSの種別')}</label>
          <span
            className="dropdown"
          >
            <select
              // 新規作成する PS の種別選択を state で実装。
              onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                setNewPsType(parseInt(event.target.value, 10));
              }}
              value={newPsType}
            >
              {
                typeOptions.map(
                  (typeOption) =>
                    <option
                      key={typeOption.value}
                      value={typeOption.value}
                    >
                      {typeOption.label}
                    </option>
                )
              }
            </select>
          </span>
        </div>
      </div>

      <div className="btnfr btnfr2 mb0 mt0 btncenter">
        <div>
          <span className="btn2 btnbg-g mr10"
            onClick={
              () => {
                setIsOpen(false);
              }
            }
          >
            <span className="modal-close2">
              {t('キャンセル')}
            </span>
          </span>
          <span>
            <input
              type='button'
              value={toString(t('作成'))}
              className='btn1 lsp1'
              disabled={newPsType < 1}
              onClick={
                () => {
                  setIsOpen(false);

                  // PS 追加画面に遷移する。以下のパラメータを渡す。
                  // ps_version_id: 追加 PS の親となる PS の PS バージョン ID
                  // type: PS 種別 1 (章 PS), 2 (タイトル PS), 3 (コンテンツ PS)
                  navigate(`/${i18n.language}/ps/add/${Number(selectedPsTreeItem.ps_version_id)}/${newPsType}`);
                }
              }
            />
          </span>
        </div>
      </div>

    </Modal>
  );
}

export default PsAddDialog;